import { render, staticRenderFns } from "./template_details.vue?vue&type=template&id=05779dc2&scoped=true"
import script from "./template_details.vue?vue&type=script&lang=js"
export * from "./template_details.vue?vue&type=script&lang=js"
import style0 from "./template_details.vue?vue&type=style&index=0&id=05779dc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05779dc2",
  null
  
)

export default component.exports